import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Collect from '../views/Collect'
import Process from '../views/Process'
import Preview from '../views/Preview'
import Responsive from '../views/Responsive'
import Personalize from '../views/Personalize'
import PageNotFound from '../views/PageNotFound'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/preview',
    name: 'Preview',
    component: Preview
  },
  {
    path: '/responsive',
    name: 'Responsive',
    component: Responsive
  },
  {
    path: '/personalize',
    name: 'Personalize',
    component: Personalize
  },
  {
    path: '/collect',
    name: 'Collect',
    component: Collect,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/process/:uuid',
    name: 'Process',
    component: Process,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: '404',
    component: PageNotFound
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(r => r.meta.requiresAuth)
  if (requiresAuth && !store.getters.hasUser) {
    next('/')
  } else {
    next()
  }
})

export default router
